// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3YfjN","text":"SelectPayment_text__1-Xz0","title":"SelectPayment_title__2ZkCG","btn":"SelectPayment_btn__1p29c"};